import NodeErrors from "./NodeErrors";
import NodeOutputs from "./NodeOutputs";

const NodeFooter = () => (
  <div className="flex flex-col">
    <NodeErrors />
    <NodeOutputs />
  </div>
);

export default NodeFooter;
